const initialReducerState = {
  color: '',
  clarity: '',
  shape: '',
  rap: '',
  carat: '0',
  price: '0',
  priceTotal: '0',
  activeInputName: 'carat',
  priceInitial: '0',
  priceTotalInitial: '0'
}

const regFloatNumber = /^\d*\.?\d{0,2}?$/

const keyboardButtons = [
  {
    value: '1',
    backspace: false
  },
  {
    value: '2',
    backspace: false
  },
  {
    value: '3',
    backspace: false
  },
  {
    value: '4',
    backspace: false
  },
  {
    value: '5',
    backspace: false
  },
  {
    value: '6',
    backspace: false
  },
  {
    value: '7',
    backspace: false
  },
  {
    value: '8',
    backspace: false
  },
  {
    value: '9',
    backspace: false
  },
  {
    value: ',',
    backspace: false
  },
  {
    value: '0',
    backspace: false
  },
  {
    value: '',
    backspace: true
  }
]

export {
  initialReducerState,
  regFloatNumber,
  keyboardButtons
}
